import axios from 'axios';

/**
 * Get the system health status 
 * Helps diagnose whether the backend is correctly configured
 */
export const getSystemHealth = async () => {
  const { data } = await axios.get('/api/system/health');
  return data;
};

/**
 * Test the connection to the external API through our proxy
 */
export const testApiConnection = async () => {
  try {
    // Use a lightweight endpoint that exercises the proxy + backend.
    const { data } = await axios.get('/api/field-mappings');
    return {
      status: 'success',
      message: 'Successfully connected to the API',
      mockData: data && data.length === 0,
      data
    };
  } catch (error: any) {
    return {
      status: 'error',
      message: error.message || 'Unknown error',
      error: error.response?.data || error.message
    };
  }
};

export interface SystemStats {
  status: string;
  timestamp: string;
  environment: string;
  apiConfigured: boolean;
  apiStatus?: 'connected' | 'disconnected' | 'unknown';
}
